import type { ColorPalette } from '@/features/colors/color.types';
import {
  NEUTRAL_COOL,
  NEUTRAL_GRAY,
  NEUTRAL_WARM,
} from '@/features/colors/neutrals';

// Slots in design's column order: pink, orange, yellow, tan, green, blue,
// purple, gray — note tan is color6, not color3. Shades by role: 500 primary
// accent, 300 muted, 100 light category, 50 shaded cell.
//
// Like the other sheet palettes, Cloud's sheet omits the warm/cool row, so the
// tie follows joyful's convention for the same eight columns.
//
// Cloud is pastel throughout: its 500 accents are lighter than most palettes'
// 300 muted steps, and lighter than the neutral step muted ink takes — so a
// muted weekend date reads slightly heavier here than the weekday beside it.
// That is deliberate; see getMutedNeutral. The gray accent is #A2ABBD; the sheet
// notes an earlier #C9C7C1 that "clashed".
export const cloudPalette: ColorPalette = {
  id: 'cloud',
  name: 'Cloud',
  description: 'Everything soft',
  requiresPaidPlan: true,
  colors: {
    cool: { ...NEUTRAL_COOL },
    gray: { ...NEUTRAL_GRAY },
    warm: { ...NEUTRAL_WARM },
    color0: {
      neutral: { ...NEUTRAL_WARM },
      shade: {
        '50': '#FBF0F5',
        '100': '#FCEBF3',
        '300': '#F9D0E4',
        '500': '#F4A9CE',
      },
    },
    color1: {
      neutral: { ...NEUTRAL_WARM },
      shade: {
        '50': '#F9F2ED',
        '100': '#FDEEE1',
        '300': '#FAE0CC',
        '500': '#F6C6A2',
      },
    },
    color2: {
      neutral: { ...NEUTRAL_WARM },
      shade: {
        '50': '#F6F3EB',
        '100': '#FBF4DD',
        '300': '#F8EFCB',
        '500': '#F3E1A0',
      },
    },
    color3: {
      neutral: { ...NEUTRAL_COOL },
      shade: {
        '50': '#EFF5F2',
        '100': '#E9F4EE',
        '300': '#D0EADD',
        '500': '#A9D9C1',
      },
    },
    color4: {
      neutral: { ...NEUTRAL_COOL },
      shade: {
        '50': '#EFF4F9',
        '100': '#E9F1FA',
        '300': '#D0E3F5',
        '500': '#A9CCEC',
      },
    },
    color5: {
      neutral: { ...NEUTRAL_COOL },
      shade: {
        '50': '#F4F2FB',
        '100': '#F0EBFB',
        '300': '#E0D6F6',
        '500': '#C7B4EF',
      },
    },
    color6: {
      neutral: { ...NEUTRAL_WARM },
      shade: {
        '50': '#F6F3EE',
        '100': '#F7F1E6',
        '300': '#F0E5D1',
        '500': '#E4CFAC',
      },
    },
    color7: {
      neutral: { ...NEUTRAL_COOL },
      shade: {
        '50': '#ECEEF2',
        '100': '#E7E9EE',
        '300': '#CCD1DB',
        '500': '#A2ABBD',
      },
    },
  },
};
